import { Component, app, context, ojs, payload, v } from "modular-openscriptjs";
import { either, eParse, hideCanvas, oneOf } from "../../helpers";
import { dom } from "../../fotastart";
import { gc, PAGES } from "../../declarations";

const h = app("h");

export default class ProfileCanvas extends Component {
	passwordId = "offcanvas-password-input";
	emailId = "offcanvas-email-input";
	rememberMeId = "offcanvas-remember-me-checkbox";

	$$ojs = {
		routeChanged: () => {
			hideCanvas("#offcanvasAccount");
		},
	};

	render(...args) {
		return h.div(
			{
				class: "offcanvas offcanvas-end",
				tabindex: "-1",
				id: "offcanvasAccount",
				aria_labelledby: "offcanvasAccountLabel",
			},
			h.div(
				{ class: "offcanvas-header" },
				h.div(
					{ class: "d-flex justify-content-between w-100" },
					h.h4(
						{
							class: "offcanvas-title fw-400",
							id: "offcanvasAccountLabel",
						},
						"Account"
					)
				),

				h.button({
					id: "cmp-show-account-canvas",
					style: "visibility:hidden;",
					class: "d-none",
					data_bs_toggle: "offcanvas",
					data_bs_target: "#offcanvasAccount",
				}),
				h.button({
					type: "button",
					class: "btn-close text-reset",
					data_bs_dismiss: "offcanvas",
					aria_label: "Close",
				})
			),
			h.div({ class: "offcanvas-body pt-0" }, this.auth(gc.auth)),

			...args
		);
	}

	auth(auth, ...args) {
		let isImpersonating = false;
		
		return h._(
			h.a(
				{
					href: "#",
					class: "d-block mt-1 mb-4",
					onclick: h.func("route.to", "user.view-profile", {
						user: "current",
					}),
				},
				h.div(
					{ class: "d-flex align-items-center gap-3" },

					either(
						auth?.value,
						h.div(
							{ class: "square-profile fw-500" },
							v(context("global").user, (user) => {
								return either(
									user?.profile_photo_path,
									h.img({
										loading: "lazy",
										class: "border border-1 rounded-circle",
										src: oneOf(
											user?.profile_photo_path,
											"/assets/images/user-avatar.png"
										),
									}),
									h.div(
										{
											class: "square-profile fw-500 text-bg-primary",
										},
										`${
											user?.first_name
												?.charAt(0)
												.toUpperCase() ?? "<"
										}${
											user?.last_name
												?.charAt(0)
												.toUpperCase() ?? ">"
										}`
									)
								);
							})
						),
						h.div(
							{ class: "square-profile fw-500 text-bg-primary" },
							"NA"
						)
					),

					h.div(
						{ class: "d-grid gap-1 lh-1" },
						h.span(
							{ class: "fs-5" },
							v(
								context("global").user,
								(u) =>
									`${u?.first_name ?? "--"} ${
										u?.last_name ?? "--"
									}`
							)
						),
						h.span(
							{ class: "text-muted" },
							v(context("global").user, (u) =>
								oneOf(u?.email, "No Email")
							)
						)
					)
				)
			),

			h.ul(
				{ class: "list-reset ms-reset py-3 border-top" },

				either(isImpersonating == true, () => [
					h.li(
						{ class: "menu-label" },
						h.small(
							{
								class: "text-primary fs-xsm text-uppercase fw-500",
							},
							"Session"
						)
					),
					h.li(
						h.a(
							{
								href: "/unimpersonate",
								class: "dropdown-item d-flex gap-2",
							},
							h.span(
								{ class: "icon" },
								h.i({ class: "fa-solid fa-power-off" })
							),
							h.span({ class: "text" }, "End Impersonation")
						)
					),
				])
			)
		);
	}
}
